export default __webpack_public_path__ + "static/media/paack.5f1a8c14.svg";